import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Decimal from "decimal.js-light";

import { downloadCSVWithBom, pz } from "../../helpers/methods";

export const exporter = (profile, locale) => (payments) => {
  const { invoiceNumberPrefix = "FBL", invoiceNumberLength } = profile;
  const paymentsForExport = payments.map((payment) => {
    const {
      __v,
      updatedAt,
      _id,
      id,
      page,
      order = {},
      paidAmount,
      createdAt,
      ...paymentForExport
    } = payment; // omit backlinks and author
    const createdTime = new Date(createdAt);
    const updatedTime = new Date(updatedAt);
    const { customerName = "", orderNumber = "", currencyCode = "" } = order;
    const newPaidAmount = new Decimal(paidAmount).dividedBy(100).toNumber();
    const fullInvoiceNumber = `${invoiceNumberPrefix}${pz(
      order.invoiceNumber,
      invoiceNumberLength
    )}`;
    const orderStatus = order.status;

    return {
      ...paymentForExport,
      createdAtDate: createdTime.toLocaleDateString(locale),
      createdAtTime: createdTime.toLocaleTimeString(locale),
      updatedAtDate: updatedTime.toLocaleDateString(locale),
      updatedAtTime: updatedTime.toLocaleTimeString(locale),
      customerName,
      orderNumber,
      orderStatus,
      currencyCode,
      paidAmount: newPaidAmount,
      invoiceNumber: fullInvoiceNumber,
      paymentId: id,
    };
  });
  const csv = convertToCSV({
    data: paymentsForExport,
    fields: [
      "paymentId",
      "customerName",
      "orderNumber",
      "orderStatus",
      "type",
      "paid",
      "paidAmount",
      "remarks",
      "invoiceNumber",
      "currencyCode",
      "createdAtDate",
      "createdAtTime",
      "updatedAtDate",
      "updatedAtTime",
    ],
  });
  downloadCSVWithBom(csv, `payments_${new Date().toLocaleDateString(locale)}`);
};
